import { memo, useEffect, useMemo, useState } from 'react';

import Media from '@picsart/growth-rc/old/MediaComponents';

import classnames from 'classnames';
import optimizeImage from 'utils/optimizeImage';

import { useTranslator } from '@picsart/rc/services/localization';
import { MediaContentProps } from './types';

const MediaContent = ({
  media,
  className = null,
  dataTestId = 'media-content',
}: MediaContentProps) => {
  const translate = useTranslator();

  const {
    mobileImageSrc,
    imageSrcLowRes,
    afterImageSrc,
    imageSrc,
    poster,
    imageForSlider,
    height,
    mobileHeight,
    quality,
    isAboveTheFold,
  } = media;

  const [optimizedImages, setOptimizedImages] = useState({
    src: '',
    poster: '',
    mobileSrc: '',
    imageLowRes: '',
    afterSrc: '',
    imageSrcForSlider: '',
  });

  useEffect(() => {
    setOptimizedImages({
      poster: poster ? optimizeImage(poster, 'min', height?.toString() || '-1', quality) : '',
      src: imageSrc ? optimizeImage(imageSrc, 'min', height?.toString() || '-1', quality) : '',
      imageSrcForSlider: imageForSlider
        ? optimizeImage(imageForSlider, 'min', height?.toString() || '-1', quality)
        : '',
      imageLowRes: imageSrcLowRes
        ? optimizeImage(imageSrcLowRes, 'min', height?.toString() || '-1', quality)
        : '',
      afterSrc: afterImageSrc
        ? optimizeImage(afterImageSrc, 'min', height?.toString() || '-1', quality)
        : '',
      mobileSrc: mobileImageSrc
        ? optimizeImage(
            mobileImageSrc,
            'min',
            mobileHeight?.toString() || height?.toString() || '-1',
            quality,
          )
        : '',
    });
  }, [
    poster,
    imageSrc,
    imageSrcLowRes,
    imageForSlider,
    afterImageSrc,
    mobileImageSrc,
    height,
    mobileHeight,
    quality,
  ]);

  const translatedAlt = useMemo(() => translate(media.alt), [media.alt, translate]);

  return (
    <div className={classnames(className, 'media')} data-testid={dataTestId}>
      <Media
        {...{ ...media, alt: translatedAlt }}
        mobileImageSrc={optimizedImages.mobileSrc}
        poster={optimizedImages.poster}
        imageSrc={optimizedImages.src}
        imageSrcLowRes={optimizedImages.imageLowRes}
        afterImageSrc={optimizedImages.afterSrc}
        isLazy
        appendCDNQuery={false}
        priority={isAboveTheFold}
        imageForSlider={optimizedImages.imageSrcForSlider}
      />
    </div>
  );
};

export default memo(MediaContent);
